import { ReactNode } from 'react'

export interface LinkProps {
  href: string
  children: ReactNode
  testId?: string
}

export const Link = ({ href, children, testId }: LinkProps) => {
  return (
    <a
      href={href}
      data-testid={testId}
      target="_blank"
      rel="noopener noreferrer"
      className="text-foreground-action-secondary inline text-sm font-medium hover:underline"
    >
      {children}
    </a>
  )
}
